/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { Card, CardContent, Grid, Stack } from '@mui/material'
import i18n from 'simple-react-i18n'
import PGSSEFilters from '../common/PGSSEFilters'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { CardTable } from 'components/datatable/NewTable'
import { push } from '@lagunovsky/redux-react-router'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import PgsseAction from 'pgsse/action/PgsseAction'
import { getLabel } from 'utils/StoreUtils'
import useTitle from 'utils/customHook/useTitle'
import { HIGH_RISK, LOW_RISK, MEDIUM_RISK } from 'pgsse/constant/PgsseConstants'
import StatsTable from './StatsTable'
import { CardTitle } from 'components/card/NewCard'
import PgsseDangerCarto from './carto/PgsseDangerCarto'
import SimpleTabList from 'components/list/SimpleTabList'
import { nbPerPageLabelHuge } from 'referencial/constants/ReferencialConstants'

const STATISTICS = 0
const MAP = 1
const RISK_VALUES = { high: 10, medium: 20, low: 50 }

const DangerList = ({ }) => {
    const dispatch = useDispatch()

    const {
        contributors,
        distributionUnits,
        sectors,
        diagnosticDangers,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnosticDangers: store.PgsseReducer.diagnosticDangers,
    }), shallowEqual)

    useEffect(() => {
        dispatch(PgsseAction.fetchDashboardPhase2List({}))
    }, [])

    const rows = diagnosticDangers.map(d => {
        return {
            ...d,
            collectivity: getLabel(contributors, d.idContributor),
            sector: getLabel(sectors, d.idSector),
            udiCode: getLabel(distributionUnits, d.idUdi, 'code'),
            udi: getLabel(distributionUnits, d.idUdi),
        }
    })

    useTitle(() => [{
        title: i18n.pgsse,
        href: PATH_PGSSE,
    }, {
        title: i18n.phase2,
        href: `${PATH_PGSSE}/phase2`,
    }], [])

    return (
        <Grid container spacing={1} sx={{ padding: '10 10 10 20' }}>
            <Grid size={12}>
                <PGSSEFilters onValidate={filters => dispatch(PgsseAction.fetchDashboardPhase2List(filters))} />
            </Grid>
            <Grid size={12}>
                <SimpleTabList
                    tabs={[
                        {
                            constant: STATISTICS,
                            label: i18n.statistics,
                            icon: 'bar_chart',
                        },
                        {
                            constant: MAP,
                            label: i18n.map,
                            icon: 'map',
                        },
                    ]}
                    noPadding
                    defaultTab={STATISTICS}
                >
                    {tab => (
                        <>
                            {tab === STATISTICS && (
                                <CardTable
                                    title={i18n.dangers}
                                    rows={rows}
                                    headers={['collectivity', 'sector', 'udiCode', 'udi',
                                        { key: 'highRisk', value: i18n[HIGH_RISK.name] },
                                        { key: 'mediumRisk', value: i18n[MEDIUM_RISK.name] },
                                        { key: 'lowRisk', value: i18n[LOW_RISK.name] },
                                    ]}
                                    onClickRow={d => {
                                        dispatch(push(`${PATH_PGSSE}/phase2/${d.idDiag}`))
                                    }}
                                    rowsPerPageOptions={nbPerPageLabelHuge}
                                />
                            )}
                            {tab === MAP && (
                                <Stack sx={{ padding: '0.65rem' }} spacing={1}>
                                    <StatsTable
                                        riskValues={RISK_VALUES}
                                    />
                                    <Card>
                                        <CardTitle title={i18n.hazardsMapping}/>
                                        <CardContent>
                                            <PgsseDangerCarto
                                                diagnostic={{}}
                                            />
                                        </CardContent>
                                    </Card>
                                </Stack>
                            )}
                        </>
                    )}
                </SimpleTabList>

            </Grid>
        </Grid>
    )
}

DangerList.PropTypes = {
}

export default DangerList